export default function PageViewWrapper({ children, canView }) {
  if (canView) return children;
  return null;
}
